import { gsap } from "gsap";
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Utils } from "../misc/Utils";
import imagesLoaded from 'imagesloaded';

export class HomeNewPageHandler extends PageHandler {
	constructor(id) {
		super(id);
	}

	showError(text) {
		jQuery('.form-status').text(text);
		jQuery('.form-status').addClass('error')
	}

	hideError() {
		jQuery('.form-status').text('');
		jQuery('.form-status').removeClass('error')
	}

	ajax() {

	}

	events() {
		
	}

	transitions() {
		
	}

	doUploadFile(file, callback) {
		var _this = this;
		var formData = new FormData();
		formData.append('epw-file', file); // Append the file to the form data
		formData.append('action', 'upload_file');
		formData.append('_ajax_nonce_upload_file', bipv_script_data.nonce_upload_file);
		gsap.set('.epw-form .loader', {display: 'block'})

		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false,
			success: function(response) {
				// console.log(response);
				if (response.success)
				{
					callback(response.data.epwId);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				_this.showError(`Error uploading file (${textStatus} - ${errorThrown})`);
			}
		});
	}

	doFetchURL(URL, callback) {
		gsap.set('.epw-form .loader', {display: 'block'})
		var _this = this;

		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: {
				'epw-url': URL,
				'action': 'fetch_URL',
				'_ajax_nonce_fetch_URL': bipv_script_data.nonce_fetch_URL
			},
			success: function(response) {
				// console.log(response)
				if (response.success)
				{
					callback(response.data.epwId);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				_this.showError(`Error uploading file (${textStatus} - ${errorThrown})`);
			}
		});
	}

	init() {
		this.events();
		var _this = this;
		var locationForm = document.querySelector('.section__get-started form.location-form');
		var epwForm = document.querySelector('.section__get-started form.epw-form');

		window.selectedLocation = '';
		window.global.initSelect('main.home .section__get-started .custom-select-wrapper', (option) => {
			window.selectedLocation = jQuery(option).data('value');
			locationForm.querySelector('input[name="location"]').value = window.selectedLocation;
		});

		const uploadArea = document.getElementById('upload-area');
		const fileInput = document.getElementById('file-input');
		const browseButton = document.getElementById('browse-button');
	
		uploadArea.addEventListener('dragover', (event) => {
			event.preventDefault();
			uploadArea.classList.add('dragover');
		});
	
		uploadArea.addEventListener('dragleave', () => {
			uploadArea.classList.remove('dragover');
		});
	
		uploadArea.addEventListener('drop', (event) => {
			event.preventDefault();
			uploadArea.classList.remove('dragover');
			const file = event.dataTransfer.files[0];
			window.uploadedFile = file;
			_this.doUploadFile(file, (id) => {
				epwForm.querySelector('input[name="epw-file-id"]').value = id; 
				epwForm.submit();
			});
		});
	
		browseButton.addEventListener('click', () => {
			fileInput.click();
		});
	
		fileInput.addEventListener('change', () => {
			const file = fileInput.files[0];
			window.uploadedFile = file;
			_this.doUploadFile(file, (id) => {
				epwForm.querySelector('input[name="epw-file-id"]').value = id; 
				epwForm.submit();
			});
		});

		jQuery('body').on('click', '.next-button input', function(e) {
			e.preventDefault();
			e.stopPropagation();
			ajaxPH.maskOn(() => locationForm.submit());
		})

		jQuery('body').on('click', '.url-check button', function(e) {
			e.preventDefault();
			e.stopPropagation();
			let url = document.querySelector('input[name="epw-url"]').value;
			_this.doFetchURL(url, (id) => {
				epwForm.querySelector('input[name="epw-file-id"]').value = id; 
				epwForm.submit()
			})
		})
	}

	destroy() {

	}
}
